import * as React from 'react';
import { LinearProgress } from '@mui/material';
import DataPoolList from './DataPoolList';
import ErrorMsg from '../common/ErrorMsg';
import PaginationNav from '../common/PaginationNav';
import usePaginatedDataPools from '../hooks/usePaginatedDataPools';
import { useNavigate } from 'react-router';

function SelectDataPool() {
  const PAGE_LIMIT = 100;
  const { data, isLoading, isFetching, isError, total, page, previousPage, nextPage, toPage } =
    usePaginatedDataPools(null, PAGE_LIMIT, '', true);

  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isLoading) {
      navigate(`#page-${page + 1}`);
    }
  }, [page]);

  React.useEffect(() => {
    if (!isLoading) {
      const hash = window.location.hash;
      if (hash) {
        const goToPage = parseInt(hash.split('-')[1]);
        if (goToPage >= 1 && goToPage <= total) {
          toPage(goToPage);
          navigate(`#page-${goToPage}`);
        } else {
          toPage(1);
          navigate(`#page-1`);
        }
      }
    }
  }, [isFetching, window.location.hash]);

  if (isLoading || isFetching) {
    return <LinearProgress />;
  }
  if (isError) {
    return <ErrorMsg error="Sorry, failed to load datapools." />;
  }

  return (
    <div id="select-datapool-list">
      {!isLoading && !isFetching && (
        <DataPoolList dataPools={data?.results.map((dp) => ({ id: dp.id, label: dp.label }))} />
      )}
      {data && data.count > PAGE_LIMIT ? (
        <PaginationNav total={total} page={page} previousPage={previousPage} nextPage={nextPage} />
      ) : null}
    </div>
  );
}

export default SelectDataPool;
